import script from "./signList.vue?vue&type=script&setup=true&lang=js"
export * from "./signList.vue?vue&type=script&setup=true&lang=js"

import "./signList.vue?vue&type=style&index=0&id=59576b1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59576b1a"]])

export default __exports__